<template>
    <v-container fluid fill-height pa-6 class="main-container">
        <v-layout justify-center align-center class="auth-layout">
            <v-flex text-center>
                <div v-html="require('!html-loader!@/assets/images/logo_image.svg')" class="d-inline-flex mb-60" />
                <p class="common-text white-text">Вход в админ-панель</p>
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    class="auth-form"
                >
                    <div class="auth-form__input mb-1">
                        <label for="email-reset" class="main-text"> E-mail </label>
                        <v-text-field
                            v-model="email"
                            id="email-reset"
                            placeholder="Введите e-mail"
                            class="dark-input"
                            :rules="rules"
                            :error="error"
                            :error-messages="errorMessage"
                            @input="deleteError"
                        ></v-text-field>
                    </div>
                    <div class="main-text mb-60 text-left">
                        На этот e-mail будет отправлено письмо с инструкцией по восстановлению пароля
                    </div>
                    <v-btn
                        :disabled="!valid"
                        class="yellow-btn"
                        @click="validate"
                    >
                        Отправить
                    </v-btn>
                    <div class="w-100 d-inline-flex justify-center mt-5">
                        <a href="#" class="auth-link" @click.prevent="openLogin">
                            Я вспомнил пароль
                        </a>
                    </div>
                </v-form>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'ResetPassword',
    data() {
        return {
            email: null,
            valid: true,
            rules: [value => !!value || 'Обязательное поле'],
            error: null,
            errorMessage: null,
        };
    },
    methods: {
        resetPassword() {
            this.$router.push({ name: "confirmemail" });
            console.log("resetPassword");
        },
        validate() {
            // this.valid = this.$refs.form.validate();
            // if (this.valid) {
                this.resetPassword();
            // } else {
            //     this.errorMessage = "Обязательное поле";
            // }
        },
        deleteError() {
            this.errorMessage = null;
            this.error = false;
        },
        openLogin() {
            this.$router.push({ name: "login" });
        }
    }
}
</script>

<style scoped>
</style>